import React from 'react';
import { Badge } from '../ui/badge';

/**
 * Shared Quick Actions card — identical footprint for Tier 1 and Tier 2.
 * Tier 1: colored fill + Premium badge. Tier 2: colored fill, no badge.
 */
export function QuickActionCard({ item, credits, premium, onClick, testId }) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      className={`group relative flex w-full min-h-[220px] flex-col gap-4 rounded-2xl border-2 p-5 sm:p-6 text-left shadow-md transition-all hover:shadow-xl hover:-translate-y-0.5 ${item.cardBg} ${item.cardBorder}`}
    >
      {premium && (
        <Badge className="absolute top-4 right-4 bg-primary text-primary-foreground border-0 text-[10px] px-2 py-0.5 font-bold uppercase tracking-wide shadow-sm">
          Premium
        </Badge>
      )}
      <div className={`flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl shadow-sm ring-1 ${item.iconWrap}`}>
        <i className={`ti ${item.icon} text-[2.25rem] leading-none ${item.iconColor}`} aria-hidden />
      </div>
      <div className={`flex flex-1 flex-col gap-2 ${premium ? 'pr-16' : ''}`}>
        <h3 className={`text-lg sm:text-xl font-extrabold uppercase tracking-wide leading-tight ${item.titleColor}`}>
          {item.label}
        </h3>
        <p className={`text-sm leading-snug ${item.descColor}`}>
          {item.description}
        </p>
      </div>
      <span className={`inline-flex w-fit items-center rounded-full px-3 py-1 text-xs font-bold ${item.creditBadge}`}>
        {credits} credits
      </span>
    </button>
  );
}
